import React from 'react';
import { SETTINGS } from 'modules/emergencies/constants';
import AvatarWrapper from 'modules/emergencies/components/ui/avatar/avatarWrapper';
import AvatarsContainer from 'modules/emergencies/components/ui/avatar/avatarsContainer';
import BodyColumn from 'modules/emergencies/components/ui/columns/bodyColumn';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';

const StyledBodyColumn = styled(BodyColumn)`
  padding: 0;
  background-color: var(--grey200);
  ${({ hasMessage }) =>
    !hasMessage &&
    css`
      background-color: var(--grey100);
    `}
`;

const StyledAvatarsContainer = styled(AvatarsContainer)`
  height: 100%;
  width: 100%;
`;

const NewCommentButtonWrapper = styled(AvatarWrapper)`
  cursor: pointer;
  padding-left: 8px;
  padding-right: 8px;
  height: 100%;
  width: 100%;
`;

export const InternalCommentColumn = ({ ticket }) => {
  const history = useHistory();
  const message = ticket?.comments?.length > 0 ? ticket?.comments[0]?.message : null;
  return (
    <StyledBodyColumn
      hasMessage={!!message}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.INTERNAL_COMMENT_BUTTON}
    >
      <StyledAvatarsContainer>
        <NewCommentButtonWrapper
          withBorderLeft={true}
          onClick={() => {
            history.push(`/emergencies/${ticket.id}`);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_3472_4850)">
              <path
                d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H18L22 24V6ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
                fill="#2396DC"
              />
            </g>
            <defs>
              <clipPath id="clip0_3472_4850">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </NewCommentButtonWrapper>
      </StyledAvatarsContainer>
    </StyledBodyColumn>
  );
};
